<template>
  <div id="loading" :class="{'active': isOpen}">
    <div id="loading__bg"></div>
    <div id="loading__content">
      <div id="lds-spinner-position">
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: {
    isOpen: {
      type: Boolean,
      value: false
    }
  }
};
</script>
